import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconBag: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <g
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M17 21v-9c0-3.866 3.134-7 7-7h0c3.866 0 7 3.134 7 7v9" />
            <path d="M38 12l.988 30.583c-1.122-.369-2.667-.691-4.521-.947l-.814-.106-.42-.05-.866-.092c-.147-.015-.296-.03-.446-.043l-.914-.08-.47-.035-.958-.065c-.324-.02-.652-.038-.985-.054l-1.01-.044c-.34-.013-.685-.024-1.033-.033l-1.053-.023c-.355-.005-.712-.009-1.072-.01L24 41c-.36 0-.718.002-1.073.006l-1.054.017h0l-1.036.029h0l-1.013.04-.498.023-.978.055-.478.031-.937.07h0l-.908.079-.441.043-.86.093h0l-.824.1-.4.054-.769.114h0l-.73.12c-1.182.209-2.192.447-2.988.709L10 12h28z" />
          </g>
        </svg>
      </div>
    </div>
  )
}
export default IconBag
